import React, { Component } from 'react'

import {parseTimestamp} from '../../../utils'

class ReservationsFinder extends Component {

    constructor(props){
        super(props)
        this.getErrorMessagesStr = this.getErrorMessagesStr.bind(this)
    }

    getErrorMessagesStr(errorMessages){
        if (errorMessages.invalidId){
            return 'El ID es invalido'
        }
        if (errorMessages.invalidName){
            return 'El nombre es invalido'
        }
        if (errorMessages.invalidPhone){
            return 'El telefono es invalido'
        }
        if (errorMessages.invalidMail){
            return 'El correo electronico es invalido'
        }
        return ''
    }

    render(){
        const {
            reservationData,
            availableHours,
            errorMessages,
            onDataChange,
            isSearchComplete
        } = this.props
        const {getErrorMessagesStr} = this
        const eventDataErrorsStr = getErrorMessagesStr(errorMessages)
        return(
            <div>
                <div className="line-header-text">Filtrar reservaciones</div>
                <div className="events-finder-search">
                    <table>
                            <tr>
                                <th className="table-left">ID de reservacion</th>
                                <th>
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={reservationData.id}
                                        placeholder="**Todos"
                                        onChange={event => {return onDataChange('id', event.target.value)}}
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">Nombre</th>
                                <th >
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={reservationData.name}
                                        onChange={event => {return onDataChange('name', event.target.value)}}
                                        placeholder="**Todos"
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">telefono</th>
                                <th >
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={reservationData.phone}
                                        onChange={event => {return onDataChange('phone', event.target.value)}}
                                        placeholder="**Todos"
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">Correo electronico</th>
                                <th >
                                <div className="input-error">
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={reservationData.mail}
                                        onChange={event => {return onDataChange('mail', event.target.value)}}
                                        placeholder="**Todos"
                                        disabled={false}
                                    />
                                </div>
                                </th>
                            </tr>
                            <tr>
                                <th className="table-left">Hora de reservacion</th>
                                <th >
                                <select
                                    className="select-css"
                                    value={reservationData.selectedTime ? reservationData.selectedTime : '**Todas'}
                                    onChange={event => {return onDataChange('time', event.target.value)}}
                                    disabled={false}
                                >
                                {
                                    availableHours.map(el => {
                                        return (
                                            <option
                                                value={el.time}
                                                key={el.time}
                                            >
                                                {parseTimestamp(el.time).time}
                                            </option>
                                        )
                                    })
                                }
                                    <option
                                        value={'**Todas'}
                                        key={'**Todas'}
                                    >
                                        {'**Todas'}
                                    </option>
                                </select>
                                </th>
                            </tr>
                        </table>
                    </div>
                    <div>
                        {
                            isSearchComplete ?
                            <div className="text-success">Resultado de la busqueda listo</div> :
                            <div className="error-message">{eventDataErrorsStr}</div>
                        }
                    </div>
            </div>
        )
    }
}

export default ReservationsFinder
